import { useTranslation } from 'react-i18next';
import { cn } from '../../../../utils/cn';

/** 4 barras de señal GSM. Color por calidad; gris las inactivas. */
export function SignalBars({ level, className }) {
  const { t } = useTranslation();
  const tone =
    level === 0 ? 'bg-status-error' : level <= 2 ? 'bg-status-warning' : 'bg-status-success';
  return (
    <span
      className={cn('inline-flex items-end gap-[2px] h-3.5', className)}
      role="img"
      aria-label={`${t('Señal')} ${level} ${t('de')} 4`}
      title={`${t('Señal GSM')} ${level}/4`}
    >
      {[1, 2, 3, 4].map((i) => (
        <span
          key={i}
          className={cn('w-[3px] rounded-[1px]', i <= level ? tone : 'bg-border')}
          style={{ height: `${i * 25}%` }}
        />
      ))}
    </span>
  );
}
